import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="border-t border-neutral-200 mt-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2">
          <div className="mb-4">
            <Logo size={32} />
          </div>
          <p className="text-sm text-neutral-600 max-w-xs">
            An editorial marketplace for things worth owning. Curated by sellers. Shipped with care.
          </p>
        </div>
        <div>
          <h4 className="font-display font-bold mb-3 text-sm uppercase tracking-wider">Shop</h4>
          <ul className="space-y-2 text-sm text-neutral-600">
            <li><Link to="/products">All products</Link></li>
            <li><Link to="/products?sort=rating">Bestsellers</Link></li>
            <li><Link to="/products?sort=newest">New arrivals</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-bold mb-3 text-sm uppercase tracking-wider">Company</h4>
          <ul className="space-y-2 text-sm text-neutral-600">
            <li><Link to="/seller/apply">Sell on MATRIX</Link></li>
            <li><a href="#">About</a></li>
            <li><a href="#">Careers</a></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-bold mb-3 text-sm uppercase tracking-wider">Help</h4>
          <ul className="space-y-2 text-sm text-neutral-600">
            <li><a href="#">Contact</a></li>
            <li><a href="#">Shipping</a></li>
            <li><a href="#">Returns</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-neutral-200">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-5 text-xs text-neutral-500 flex items-center justify-between">
          <span>© {new Date().getFullYear()} MATRIX Marketplace. All rights reserved.</span>
          <span>Built for a better commerce.</span>
        </div>
      </div>
    </footer>
  );
}
